import {computed} from "vue";
import {useStore} from "vuex";
import useImageBuilder from "../helpers/useImageBuilder"
export default function(){
  const store = useStore()
  const results = computed(() => {
    return store.state.moduleA.results
  })
  // const {step5Data, step5Check, step5Check2, step2Check} = useImageBuilder()
  const ringPriceTable = [
    //2~12.5号
    //1.8/2.0mm  2.2/2.4mm, 2.6/2.8mm, 3.0/3.2,  3.4/3.6mm, 3.8mm  
      [70000,    80000,     90000,     100000,   115000,    125000], //K18YG / K18PG / K18GG
      [80000,    90000,     100000,    110000,   125000,    135000], //K18CG / K18WG / K20YG
      [88000,    98000,     110000,    120000,   135000,    145000], //Pt(950 or 900)
      [95000,    105000,    115000,    130000,   140000,    155000], //K18GY / K20PG 
    // 13~22号 bigRingPriceTable 
    //1.8/2.0mm  2.2/2.4mm, 2.6/2.8mm, 3.0/3.2,  3.4/3.6mm, 3.8mm  
      [80000,    90000,     100000,    110000,   125000,    135000], //K18YG / K18PG / K18GG
      [90000,    100000,    110000,    120000,   135000,    145000], //K18CG / K18WG / K20YG
      [98000,    108000,    120000,    130000,   145000,    155000], //Pt(950 or 900)
      [105000,    115000,   125000,    140000,   150000,    160000], //K18GY / K20PG
  ]
  let priceArray = []
  let step2Check = false
  // let step5Check2 = false
  // let step5Check5 = false //original
  let step7Check = false
  let step9Check = true
  let step5Val = {}
  
  // console.log(results.value)
  let ringBase = ""
  if (results.value.length > 0){
    ringBase = results.value.find(item => {
      return item.step === 1
    }).val
  }

  if (results.value.length > 1){
    const ringShape = results.value.find(item => {
      return item.step === 2
    }).val
    step2Check = ["softFlat"].includes(ringShape)
    // console.log("he",step2Check)
  }

  if (results.value.length > 4){
    step5Val = results.value.find(item => {
      return item.step === 5
    })
    // step5Check2 = !["2.4mm" , "2.6mm"].includes(step5Val.val)
    // step5Check5 = !["2.6mm" , "2.8mm"].includes(step5Val.val) //original
  }

  if (results.value.length > 6){
    const step7Val = results.value.find(item => {
      return item.step === 7
    })
    if(step7Val){
      step7Check = ["hineridome"].includes(step7Val.val)
    }
  }

  if (results.value.length > 6){
    const step9Val = results.value.find(item => {
      return item.step === 9
    })
    // const targetVal = ["block" , "cursive" , "undecided"];
    let arrangeStep9Val = []
    if(step9Val){
      arrangeStep9Val = step9Val.val.split(/_/g)
      step9Check = ["block" , "cursive" , "undecided"].includes(arrangeStep9Val[0])
    }
  }






  for (let index = 0; index < 10; index++) {
    let lastPrice = 0;
    let stepData = results.value.find(item => {
      return item.step === index + 1
    })
    
    if(stepData) {
      if(stepData.hasOwnProperty('price')){
        lastPrice = stepData.price;

        // if(stepData.step === 5){
        //   lastPrice = 0;
        // }
  
        if(stepData.step === 7){
          // ひねりどめ
          if(step7Check){
            if(step2Check){//has 5diamonds
              lastPrice = 35000;
            }else{//has 7 diamonds
              lastPrice = 47000;
            }
            // lastPrice = 40000;//original
          }
        }
  
        if(stepData.step === 9 && !step9Check && stepData.option) {
          const textNum = stepData.option.replace(/\s+/g, "").length;
          if(textNum > 20) {
            lastPrice = 300 * (textNum - 20) + lastPrice;
          }
        }
  
      }
      // alternative calc
      if(stepData.step === 10){
        stepData.val = Number(stepData.val)
        let size_off = (parseFloat(stepData.val)>12.5)?4:0
        let width_index = 0
        let base_index = 0

        if(["K18YG","K18PG","K18GG"].includes(ringBase)) base_index = 0
        if(["K18CG","K18WG","K20YG"].includes(ringBase)) base_index = 1
        if(["PT"].includes(ringBase)) base_index = 2
        if(["K18GY","K20PG"].includes(ringBase)) base_index = 3

        if(["1.8mm" , "2.0mm"].includes(step5Val.val)) width_index = 0 
        if(["2.2mm" , "2.4mm"].includes(step5Val.val)) width_index = 1 
        if(["2.6mm" , "2.8mm"].includes(step5Val.val)) width_index = 2 
        if(["3.0mm" , "3.2mm"].includes(step5Val.val)) width_index = 3 
        if(["3.4mm" , "3.6mm"].includes(step5Val.val)) width_index = 4 
        if(["3.8mm"].includes(step5Val.val)) width_index = 5
        priceArray[0] =  ringPriceTable[base_index+size_off][width_index]
      }
      
    }
    priceArray.push(lastPrice);
  }
  // console.log(priceArray)
  return {priceArray}
}